import { Injectable } from '@angular/core';
import { Destroyer, trimUrl } from '@apps/tools';
import { Router, NavigationEnd } from '@angular/router';
import { ProductType } from '@apps/api-interfaces';
import { BehaviorSubject } from 'rxjs';
import { takeUntil, filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ThemeService extends Destroyer {
  productSubject: BehaviorSubject<ProductType> = new BehaviorSubject<
    ProductType
  >('prad');
  product$ = this.productSubject.asObservable();

  get currentProduct(): ProductType {
    return this.productSubject.getValue();
  }

  constructor(private router: Router) {
    super();
    this.init();
  }

  init() {
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter(e => e instanceof NavigationEnd),
        map((e: NavigationEnd) => {
          const path = trimUrl(e.url).split('/');
          let type = path && path[1];
          if (type === 'kalkulator' || (path && path[1] === 'artykuly')) {
            type = path[2];
          }

          if (['prad', 'gaz', 'fotowoltaika'].includes(type)) {
            return type;
          }

          return 'prad';
        })
      )
      .subscribe((type: ProductType) => {
        this.productSubject.next(type);
      });
  }
}
